import { ApplicationStyles } from '../../Themes/'

export default {
  ...ApplicationStyles.screen
}
